<template>
  <component :is="component" :class="rootClassName">
    <slot />
  </component>
</template>

<script>

export default {
  name: 'List',

  props: {
    component: {
      type: [ Object, String ],
      default: 'ul'
    },

    className: {
      type: String
    }
  },

  computed: {
    rootClassName () {
      return [
        'list-none',
        'm-0',
        'p-0',
        this.$style.root,
        this.className
      ]
    }
  }
}

</script>

<style module>

.root {
  @apply
    flex
    flex-col;
}

</style>
